<app-traitement-data titre="IPAP 95" [sousTitre]="patient!.tableauDeBord?.ipap95?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.ipap95?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.ipap95?.value ?? 'Pas de donnée' }}
</app-traitement-data>